import React, { useContext, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { Store } from '../Store';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../utils';
import { api } from "../Api";

export default function WithdrawHistoryScreen() {
  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo } = state;
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const page = sp.get('page') || 1;
  const initData = [
    {
      from: '',
      to: 'Loading',
      amount: '',
      created: '',
    },
  ];

  const [totalUsers, setTotalUsers] = useState();
  const [totalPages, setTotalPages] = useState();
  const [history, setHistory] = useState(initData);
  const [selectedIds, setSelectedIds] = useState([]);
  const fetchData = async () => {
    try {
      const { data } = await axios.get(
        api + `/api/users/withdrawhistory?page=${page}`,
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      setHistory(data.products);
      setTotalPages(data.pages);
      setTotalUsers(data.countProducts);
    } catch (error) {
      toast.error(getError(error));
    }
  };
  useEffect(() => {
    fetchData();
  }, [page, userInfo]);

  function gotoHome() {
    navigate('/history');
  }

  return (
    <div>
      <Helmet>
        <title>Withdraw History </title>
      </Helmet>
      <Container className="no-gutter" style={{}}>
        <div className="card">
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <img
                src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                style={{ width: '15rem', margin: '2rem' }}
                alt="ClickCart Logo"
              />
            </Col>
          </Row>
          <div
            className="card-header"
            onClick={() => {
              gotoHome();
            }}
          >
            <i class="fa fa-long-arrow-left" aria-hidden="true"></i> {'  '}{' '}
            Withdraw History
          </div>
          <div className="card-body" style={{ margin: 'auto' }}></div>
          {selectedIds.length > 0 && (
            <div className="text-end mb-2" style={{ width: '95%', margin: '0 auto' }}>
              <a
                className="btn btn-outline-success btn-sm"
                target="_blank"
                rel="noreferrer"
                href={`${api}/api/invoices/withdraw/bulk.pdf?ids=${selectedIds.join(',')}&token=${userInfo.token}&download=1`}
              >
                Download {selectedIds.length} selected as PDF
              </a>
            </div>
          )}
          <Table responsive style={{ width: '95%', margin: 'auto' }}>
            <thead>
              <tr>
                <th></th>
                <th>Payment Method</th>
                <th>Destination</th>
                <th>Payable Amount</th>
                <th>Charge</th>
                <th>Total Amount</th>

                <th>Date</th>
                <th>Status</th>
                <th>Report</th>
              </tr>
            </thead>
            <tbody>
              {history.map((product) => (
                <tr key={product._id}>
                  <td>
                    <Form.Check
                      checked={selectedIds.includes(product._id)}
                      onChange={(e) =>
                        setSelectedIds((prev) =>
                          e.target.checked
                            ? [...prev, product._id]
                            : prev.filter((id) => id !== product._id)
                        )
                      }
                    />
                  </td>
                  <td>
                    {product.paymentmethod === 'self_topup' || product.paymentmethod === 'merchant'
                      ? '—'
                      : product.paymentmethod}
                  </td>
                  <td>
                    {product.withdrawKind === 'merchant' ? (
                      <div className="d-flex align-items-center gap-1">
                        {product.merchantLogo && (
                          <img
                            src={product.merchantLogo}
                            alt=""
                            style={{ width: 20, height: 20, borderRadius: '50%', objectFit: 'cover' }}
                          />
                        )}
                        <Badge bg="primary">{product.merchantName || product.to}</Badge>
                      </div>
                    ) : product.to === 'Self Topup' ? (
                      <Badge bg="info">Self Topup</Badge>
                    ) : (
                      product.to
                    )}
                  </td>
                  <td>{product.amount}</td>
                  <td>{product.charge}</td>
                  <td>{product.amount + product.charge}</td>

                  <td>
                    {product.createdAt
                      ? product.createdAt.substring(0, 10)
                      : ''}
                  </td>
                  <td>
                    {product.status ? (
                      <Badge bg="success">Paid at {product.paidAt?.substring(0, 10)}</Badge>
                    ) : product.withdrawKind === 'merchant' ? (
                      <Badge bg="warning" text="dark">Waiting for merchant</Badge>
                    ) : (
                      <Badge bg="danger">Pending</Badge>
                    )}
                  </td>
                  <td>
                    <a
                      className="btn btn-info btn-sm"
                      target="_blank"
                      rel="noreferrer"
                      href={`${api}/api/invoices/withdraw/${product._id}.pdf?token=${userInfo.token}&download=1`}
                    >
                      PDF
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <nav aria-label="..." style={{ margin: '1rem' }}>
            <ul className="pagination">
              <Link
                className={
                  parseInt(page) - 2 < 1 ? 'page-link disabled' : 'page-link'
                }
                to={`/withdrawhistory?page=${parseInt(page) - 2}`}
              >
                Previous
              </Link>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) - 1 < 1 ? 'page-link disabled' : 'page-link'
                  }
                  to={`/withdrawhistory?page=${parseInt(page) - 1}`}
                >
                  {parseInt(page) - 1}
                </Link>
              </li>
              <li className="page-item active">
                <span className="page-link">
                  {parseInt(page)}
                  <span className="sr-only">(current)</span>
                </span>
              </li>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) + 1 > totalPages
                      ? 'page-link disabled'
                      : 'page-link'
                  }
                  to={`/withdrawhistory?page=${parseInt(page) + 1}`}
                >
                  {parseInt(page) + 1}
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) + 2 > totalPages
                      ? 'page-link disabled'
                      : 'page-link'
                  }
                  to={`/withdrawhistory?page=${page + 2}`}
                >
                  Next
                </Link>
              </li>
            </ul>
          </nav>

          <div style={{ height: '51vh' }}> {''}</div>
        </div>
      </Container>
    </div>
  );
}
